import { WorkflowNode, WorkflowNodeId } from '@ply-io/ply-front-shared-utilities';

import {
	calcAndGetExtraFields,
	closeSideBar,
	resetAndHandleAutofill,
	setEditNode,
	setIsNodeDataLoading,
	syncEditNodeWithNodeData,
	updateSideBarState,
	setEditNodeID,
	setForceLoadDynamicFields,
} from '@/store/modules/selectedNode/actions';
import { useStore } from '@/utils/store';

export const useSelectedNodeActions = () => {
	const { dispatch } = useStore();
	return {
		closeSideBar: (payload?: { avoidRedirect: boolean }) => dispatch<undefined | { avoidRedirect: boolean }, void>(closeSideBar, payload),
		syncEditNodeWithNodeData: () => dispatch<undefined, void>(syncEditNodeWithNodeData, undefined),
		resetAndHandleAutofill: () => dispatch<undefined, void>(resetAndHandleAutofill, undefined),
		setEditNode: (node: WorkflowNode) => dispatch<{ node: WorkflowNode }, void>(setEditNode, { node }),
		calcAndGetExtraFields: (compareOld: boolean) => dispatch<{ compare: boolean }, void>(calcAndGetExtraFields, { compare: compareOld }),
		updateSideBarState: () => dispatch<undefined, void>(updateSideBarState, undefined),
		setIsNodeDataLoading: (isLoading: boolean) => dispatch<boolean, void>(setIsNodeDataLoading, isLoading),
		setEditNodeID: (id: WorkflowNodeId | string) => dispatch<{ id: WorkflowNodeId | string }, void>(setEditNodeID, { id }),
		setForceLoadDynamicFields: (forceLoad: boolean) => dispatch<boolean, void>(setForceLoadDynamicFields, forceLoad),
	};
};
